module.exports = new __parcel__URL__("benefits-banner.3db808f6.png").toString();